import React from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view"
import FieldString_RenderEditableInlineInput from "../../string/render/inline-editable/input-editable-inline"

const debug = false
// const debug = "FieldCopyContent_FormElementView"

export default function FieldCopyContent_FormElementView(props:FieldFormElementViewProps) {

    debug && console.log(debug, 'render', props)

    const disabled  = _.get(props, 'disabled', false)
    const value     = props.model[props.field.fieldId]

    // we need on change here to apply Min or MAX value
    const onChange = (value:any) => {
        value = props.field.normalizeValue(value)
        if (props.onChange) props.onChange(value)
    }

    debug && console.log(debug, 'render disabled', disabled)

    return <FieldString_RenderEditableInlineInput viewClasses          = {Classes("ui5-txt-default ui5-field-form-editable fl-sb h-36 p-l-10 p-r-3", props.className)}
                                                  editClasses          = {Classes("ui5-txt-default ui5-field-form-editable fl-sb h-36 p-l-10 p-r-3", props.className)}
                                                  field                = {props.field}
                                                  value                = {value}
                                                  disabled             = {disabled}
                                                  onChange             = {onChange}
                                           // onImmediateChange    = {props.onChange} - eto izmenyaetsya vo vremya redaktirovaniya
    />

}